import { AsyncSelect } from "@greco/components";
import debounce from "debounce-promise";
import React from "react";
import { useTranslation } from "react-i18next";

import { searchClients } from "api/api";
import { useRemindersStore } from "store/RemindersStore";

const SearchPayers = () => {
  const { t } = useTranslation();
  const [{ searchPayersSelectedItem }, { setRemindersStoreValues }] =
    useRemindersStore();

  return (
    <div data-help="reminders-payer">
      <AsyncSelect
        id="remindersPayersSearchWide"
        loadOptions={debounce(async (input) => {
          const trimmedInput = input.trim();
          if (trimmedInput.length === 0) return [];
          const clients = await searchClients(trimmedInput);
          return clients.data.map((c) => {
            return {
              label:
                c.name + (c.internalNumber ? ` (${c.internalNumber})` : ""),
              value: c,
            };
          });
        }, 300)}
        clearable
        placeholder={t("pct.searchPayers.label")}
        noOptionsMessage={() => t("greco.noResults")}
        isClearable
        loadingMessage={() => t("greco.searching")}
        value={searchPayersSelectedItem}
        onChange={(value) => {
          // filtering by client and by payer are mutually exclusive
          setRemindersStoreValues(
            value
              ? {
                  searchPayersSelectedItem: value,
                  searchClientsSelectedItem: null,
                }
              : { searchPayersSelectedItem: value }
          );
        }}
      />
    </div>
  );
};

export default SearchPayers;
